import type ProfileStore from "../../../stores/ProfileStore";
import type {ColSpec} from "../../../components/table/MithraTableHeadColumns";
import {environment} from "../../../env.ts";

export function getContractInsightsColumns(p: ProfileStore): ColSpec[] {
    const arr: (ColSpec | null)[] = [
        {cls: 'col-dropdown', txt: '', align: 'center'},
        environment.isDemo ? null : {cls: 'col-filename', txt: 'Filename', align: 'center', width: 200},
        {cls: 'col-type', txt: 'Type'},
        {cls: 'col-company', txt: 'Company (Legal name)'},
        {cls: 'col-supplier', txt: 'Supplier (Legal name)'},
        {cls: 'col-payment', txt: 'Payment terms'},
        {cls: 'col-effective-date', txt: 'Effective date'},
        {cls: 'col-expiration-date', txt: 'Expiration date'},
        {cls: 'col-evergreen', txt: 'Evergreen'},
        {cls: 'col-auto-renewal', txt: 'Auto Renewal'},
        {cls: 'col-incoterms', txt: 'Incoterms'},
        {cls: 'col-button', txt: '', align: 'center', width: 150}
    ];

    return arr.filter(c => c) as ColSpec[];
}
